import { LitElement as l, unsafeCSS as _ } from "lit";
import { property as a } from "lit/decorators.js";
import { booleanType as d } from "../../utils/property-types.js";
import c from "./textarea.style.css.js";
import { template as p } from "./textarea.template.js";
var v = Object.defineProperty, b = Object.getOwnPropertyDescriptor, o = (u, e, t, i) => {
  for (var s = i > 1 ? void 0 : i ? b(e, t) : e, r = u.length - 1, h; r >= 0; r--)
    (h = u[r]) && (s = (i ? h(e, t, s) : h(s)) || s);
  return i && s && v(e, t, s), s;
};
class n extends l {
  constructor() {
    super(), this.autoHeight = !1, this.size = "lg", this.icon = void 0, this._maxLength = 0, this._isTextareaFocused = !1, this._isGroupFocusedVisible = !1, this._showError = !1, this.observerConfig = { attributes: !0, childList: !0, subtree: !0 }, this.callback = (e) => {
      for (const t of e)
        t.type === "attributes" && this._checkAttributes();
      this.requestUpdate();
    }, this.observer = new MutationObserver(this.callback), this._handleInputBound = this._handleInput.bind(this), this._handleFocusBound = this._handleFocus.bind(this), this._handleFocusOutBound = this._handleFocusOut.bind(this), this._handleBlurBound = this._handleBlur.bind(this), this._handleLabelClickBound = this._handelLabelClick.bind(this), this._handleKeyupBound = this._handleKeyup.bind(this);
  }
  static get styles() {
    return _(c);
  }
  set value(e) {
    e !== void 0 && this.requestUpdate();
  }
  get value() {
    return this._textarea ? this._textarea.value : "";
  }
  set showError(e) {
    const t = this._showError;
    this._showError = e, this.requestUpdate("showError", t);
  }
  get showError() {
    return this._showError;
  }
  get _label() {
    var t;
    const e = ((t = this.shadowRoot) == null ? void 0 : t.querySelector('slot[name="label"]')) || void 0;
    return e == null ? void 0 : e.assignedElements()[0];
  }
  get _textarea() {
    var t;
    const e = ((t = this.shadowRoot) == null ? void 0 : t.querySelector('slot[name="textarea"]')) || void 0;
    return e == null ? void 0 : e.assignedElements()[0];
  }
  get _description() {
    var t;
    const e = ((t = this.shadowRoot) == null ? void 0 : t.querySelector('slot[name="description"]')) || void 0;
    return e == null ? void 0 : e.assignedElements()[0];
  }
  disconnectedCallback() {
    var e, t, i, s, r, h;
    this.observer.disconnect(), (e = this._textarea) == null || e.removeEventListener("input", this._handleInputBound), (t = this._textarea) == null || t.removeEventListener("focus", this._handleFocusBound), (i = this._textarea) == null || i.removeEventListener("focusout", this._handleFocusOutBound), (s = this._textarea) == null || s.removeEventListener("blur", this._handleBlurBound), (r = this._textarea) == null || r.removeEventListener("keyup", this._handleKeyupBound), (h = this._label) == null || h.removeEventListener("click", this._handleLabelClickBound);
  }
  _checkAttributes() {
    if (this._textarea) {
      const { maxLength: e } = this._textarea;
      this._maxLength = e > 0 ? e : 0;
    }
  }
  async firstUpdated() {
    try {
      await this.updateComplete, this._checkAttributes(), this._addEventListeners(), this.autoHeight && this._updateHeight(), this.requestUpdate(), this.observer.observe(this._textarea, this.observerConfig);
    } catch (e) {
      console.error("ERROR OCURRED", e);
    }
  }
  _addEventListeners() {
    var e;
    this._textarea.addEventListener("input", this._handleInputBound), this._textarea.addEventListener("focus", this._handleFocusBound), this._textarea.addEventListener("focusout", this._handleFocusOutBound), this._textarea.addEventListener("blur", this._handleBlurBound), (e = this._label) == null || e.addEventListener("click", this._handleLabelClickBound), this._textarea.addEventListener("keyup", this._handleKeyupBound);
  }
  _updateHeight() {
    this._textarea.style.height = "auto", this._textarea.style.height = `${this._textarea.scrollHeight}px`;
  }
  _handleInput() {
    this.autoHeight && this._updateHeight(), this._showError = !this._textarea.checkValidity(), this.requestUpdate();
  }
  _handleKeyup(e) {
    (e.keyCode ? e.keyCode : e.which) === 9 && this._handleFocus();
  }
  _handleFocus() {
    this._isGroupFocusedVisible = !0, this._isTextareaFocused = !0, this.requestUpdate();
  }
  _handleFocusOut() {
    this._handleBlur(), this._isGroupFocusedVisible = !1, this._isTextareaFocused = !1, this.requestUpdate();
  }
  _handleBlur() {
    this._isTextareaFocused = !1, this.requestUpdate();
  }
  _handelLabelClick() {
    this._textarea.focus(), this.requestUpdate();
  }
  _handleSlotChange() {
    this.requestUpdate();
  }
  render() {
    return p(this);
  }
}
o([
  a({ type: String })
], n.prototype, "value", 1);
o([
  a(d)
], n.prototype, "showError", 1);
o([
  a(d)
], n.prototype, "autoHeight", 2);
o([
  a({ type: String })
], n.prototype, "size", 2);
o([
  a({ type: String })
], n.prototype, "icon", 2);
export {
  n as Textarea
};
//# sourceMappingURL=textarea.js.map
